import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { WhiteLabelService } from "app/core/white-label/white-label.service";
import { Link } from "app/core/white-label/white-label.type";
import { LinkComponent } from "app/shared/components/link/link.component";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
  imports: [LinkComponent, TranslateModule, CommonModule],
})
export class FooterComponent implements OnInit {
  public legalLinks: Link[] = [];

  constructor(private whiteLabelService: WhiteLabelService) {}

  public ngOnInit(): void {
    this.legalLinks = this.whiteLabelService.data.legalLinks;
  }
}
